import { EffectsModal } from '../EffectsModal';

export const DeathsModal = ({ title }) => EffectsModal({
  title,
  desc: 'Whenever possible, numbers of deaths are listed.',
});
